import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { AvaliacaoService } from '../../../core/config/services/avaliacao.service';
import { NotificationService } from '@app/core/services/notification.service';

@Component({
  selector: 'app-publicacao-anual-modal',
  templateUrl: './publicacao-anual-modal.component.html'
})
export class PublicacaoAnualModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() colunas: any[] = [];
  @Input() linhas: any[] = [];
  @Input() turmaId: number | null = null;
  @Input() colunaMedia: any = null;
  
  @Output() fechado = new EventEmitter<void>();
  @Output() togglePublicacao = new EventEmitter<any>();

  itens: any[] = [];

  constructor(
    private avaliacaoService: AvaliacaoService,
    private notificationService: NotificationService
  ) {}

  ngOnChanges() {
    if (this.isOpen) {
      this.mapearItens();
    }
  }

  private mapearItens(): void {
    this.itens = [];
    const tiposPublicaveis = ['PERIODO_AVALIATIVO', 'MEDIA_FINAL', 'INSTRUMENTO', 'MEDIA_PERIODO'];

    const processarColuna = (col: any, isMedia: boolean, colIndex: number) => {
      let notaRef: any = null;
      for (const linha of this.linhas) {
        const nota = isMedia ? linha.notaMediaPeriodo : (linha.notas && linha.notas[colIndex]);
        if (nota) {
          notaRef = nota;
          break;
        }
      }

      const avaliavelFonte = notaRef?.avaliavel || col.rawValue || col.itemAvaliavel || col;

      if (!avaliavelFonte || !tiposPublicaveis.includes(avaliavelFonte.tipoPeriodo)) {
        return;
      }

      if (avaliavelFonte.id) {
        this.itens.push({
          descricao: avaliavelFonte.descricao || col.descricao || 'Período',
          nota: notaRef || { avaliavel: avaliavelFonte },
          id: Number(avaliavelFonte.id),
          publicado: !!(avaliavelFonte.publicavel?.publicado ?? avaliavelFonte.publicado),
          loading: false
        });
      }
    };

    this.colunas.forEach((col, index) => processarColuna(col, false, index));

    if (this.colunaMedia) {
      processarColuna(this.colunaMedia, true, -1);
    }
  }

  onToggle(item: any): void {
    if (item.loading) return;

    const isPublicado = !!(item.nota.avaliavel.publicavel?.publicado ?? item.nota.avaliavel.publicado);

    if (isPublicado) {
      this.togglePublicacao.emit(item.nota);
    } else {
      if (!this.turmaId) return;
      item.loading = true;
      this.avaliacaoService.publicarItemAvaliavel(this.turmaId, item.id).subscribe({
        next: (res) => {
          item.loading = false;
          item.nota.avaliavel.publicavel = res.publicavel || res;
          item.nota.avaliavel.publicado = true;

          this.notificationService.success({ 
            title: 'Publicação concluída', 
            message: `A publicação de ${item.descricao} foi realizada com sucesso.` 
          });
        },
        error: () => {
          item.loading = false;
          this.notificationService.error({ 
            title: 'Erro', 
            message: `Não foi possível publicar ${item.descricao}.` 
          });
        }
      });
    }
  }

  onClose(): void {
    this.isOpen = false;
    this.fechado.emit();
  }
}
